export const UPDATE_INVOICES = 'UPDATE_INVOICES';
export const UPDATE_RECENT_VIEWED_COURSE = 'UPDATE_RECENT_VIEWED_COURSE';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';
export const SET_LATEST_INVOICE = 'SET_LATEST_INVOICE';
export const SET_CANCELLATION_REQUEST = 'SET_CANCELLATION_REQUEST';